import { push, replace, goBack } from 'react-router-redux';

import { resetSelectedItem, setCacheBuster } from 'Actions/MetaActions';
import { refreshPage, setGlobalNotification, getFetchConfig } from 'Actions/GlobalMetaActions';
import { trackGAEvent } from 'Actions/adsActions';
import { pathToThread, pathToPost } from 'Utils/nav/NavHelpers';
import { showReplyModalLoader, hideReplyModalLoader, hideReplyModal, displayNotification } from 'Actions/UiActions';

export function sendReply( user, data ) {
	return ( dispatch, getState ) => {

		dispatch( showReplyModalLoader() );

		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			body = `${ Object.keys( data ).map( ( key ) => `${key}=${data[ key ]}` ).join( '&' ) }`,
			config = dispatch( getFetchConfig( true, 'POST', body ) );

		return fetch( `${url}?v=3.0&ajax=1&uid=${user.id}&req=post`, config ).then( ( response ) => {

			dispatch( hideReplyModalLoader() );

			if( !response.ok ) {
				try {
					response.json().then( ( json ) => {
						setGlobalNotification( dispatch, json, response );
					} ).catch( () => {
						setGlobalNotification( dispatch, {}, response );
					} );
				} catch( e ) {
					setGlobalNotification( dispatch, {}, response );
				}

			} else {
				switch( data.type ) {
					case 'topic':
						response.json().then( ( json ) => {
							dispatch( hideReplyModal() );

							// Update CacheBuster
							let cacheBust = new Date().getTime();
							dispatch( setCacheBuster( cacheBust ) );

							// Record the Google Analytics event and for the forum.
							dispatch( trackGAEvent( true, 'newTopic', 'userAction', 'creation' ) );

							dispatch( replace( pathToThread( json.post.data[ 0 ].topic ) ) )
						} );
						break;

					case 'pm':
						dispatch( resetSelectedItem() );
						dispatch( hideReplyModal() );
						displayNotification( 'success', 'Message sent', { timeout: 1500 } );

						// Record the Google Analytics event and for the forum.
						dispatch( trackGAEvent( true, 'sentMessage', 'userAction', 'creation' ) );
						// Record the Google Analytics event
						dispatch( trackGAEvent( false, ( data.reply ? 'messageReply' : 'messageNew' ), 'userAction', 'creation' ) );

						dispatch( refreshPage() );
						break;

					case 'reply':
					case 'edit':
						dispatch( resetSelectedItem() );
						dispatch( goBack() );
						dispatch( hideReplyModal() );
						response.json().then( ( json ) => {
							if( json.post.data && json.post.data[ 0 ].id ) {
								// Update CacheBuster
								let cacheBust = new Date().getTime();
								dispatch( setCacheBuster( cacheBust ) );

								// Record the Google Analytics event and for the forum.
								dispatch( trackGAEvent( true, ( data.type === 'reply' ? 'newReply' : 'editPost' ), 'userAction', 'creation' ) );

								// go to the postid given back from the site
								dispatch( replace( pathToPost( json.post.data[ 0 ].id ) ) );
							} else {
								dispatch( refreshPage() );
							}
						} );
						break;

					default:
						break;
				}
			}
		} );
	};
}




// WEBPACK FOOTER //
// ./src/actions/ReplyActions.js